export default __webpack_public_path__ + "static/picasso-punks-08817cd411280f2eda8524090b3f301b.png";